export default __webpack_public_path__ + "static/media/cap3logo.fb96afa5.png";